import { useState } from 'react';
import { Box } from '@chakra-ui/react';

import { Form } from '@app/components/common/form/form';
import Dialog from '@app/components/common/modals/dialog';
import { AutocompleteField } from '@app/components/common';
import { useAlert, useApi, useAutocomplete, useEntityState } from '@app/hooks';
import { MasterOutlet } from '@app/api/models';
import { useQueryTable } from '@app/components/common/table/query-table';

import { CreateTxInstance, FormProps } from './types';
import { EquipsField } from './components/EquipsField';
import { OutletField } from './components/OutletField';
import { TX_TYPE_MOVING } from '../transactions/mock/tx-types';

export const MovingForm = ({ open, onCancel, onSubmit }: FormProps) => {
  const { error } = useAlert();
  const [instance, onChange] = useEntityState<CreateTxInstance>({
    type: TX_TYPE_MOVING
  });
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const getAutocomplete = useAutocomplete();
  const { refetch } = useQueryTable();

  const onSubmitForm = async (instance: CreateTxInstance) => {
    setLoading(true);
    await onSubmit(instance);
    await refetch();
    setLoading(false);
  };

  const onOutletFromChange = async (value: MasterOutlet) => {
    if (!value?.id) {return;}
    if (!value.room_type) {
      error('Для данной ТТ не указан тип (склад/ТТ/офис)');
      onChange('from')(undefined);
    }
  };

  const onOutletToChange = async (value: MasterOutlet) => {
    if (!value?.id) {return;}
    if (!value.room_type) {
      error('Для данной ТТ не указан тип (склад/ТТ/офис)');
      onChange('to')(undefined);
      return;
    }
    onChange('distr')(value?.distributor);
  };

  const isValid = !!instance.from && !!instance.to && !!instance.distr && !!instance.equips?.length;
  return <Dialog 
    open={open}
    onClose={onCancel}
    loading={loading}
    title="Перемещение"
    width='fit-content'
  >
    <Box mb={-4} minW={{ md: '600px' }}>
      <Form<CreateTxInstance>
        instance={instance} 
        onSubmit={onSubmitForm} 
        onCancel={onCancel}
        onChange={onChange}
        submitText="Создать"
        disabled={!isValid}
      >
        <Form.Item<CreateTxInstance, EntityBase>
          span={{ md: 12 }}
          label="Точка отправления"
          field='from'
          required
          component={OutletField}
          onChange={onOutletFromChange}
        />
        <Form.Item<CreateTxInstance, EntityBase>
          span={{ md: 12 }}
          label="Точка назначения"
          field='to'
          required
          component={OutletField}
          onChange={onOutletToChange}
        />
        <Form.Item<CreateTxInstance, EntityBase>
          span={{ md: 12 }}
          label="Дистрибьютор (исполнитель)"
          field='distr'
          component={AutocompleteField}
          componentProps={{
            name: 'distributors',
            valueProperty: 'name',
            onFetchOptions: getAutocomplete,
          }}
        />
        <Form.Divider />
        <Form.Item 
          span={{ md: 12 }}
          field='equips'
          component={EquipsField}
          key={instance.from?.id}
          componentProps={{
            disabled: !instance.from,
            outlet: instance.from,
          }}
        />
      </Form>
    </Box>
  </Dialog>;
};